import { HttpContextToken } from '@angular/common/http';

/**
 * HttpContextToken to skip global loading overlay
 */
export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

